// hooks/useOwnerAuthCheck.js
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const api = axios.create({
  baseURL: 'https://twiqli-server-vercel.vercel.app/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const useOwnerAuthCheck = () => {
  const { isOwnerAuthenticated, ownerToken, ownerLogout } = useAuth();
  const [isTokenValid, setIsTokenValid] = useState(true);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenValidity = async () => {
      if (isOwnerAuthenticated && ownerToken) {
        try {
          await api.get('/auth/verify-owner-token', {
            headers: { Authorization: `Bearer ${ownerToken}` },
          });
          setIsTokenValid(true);
        } catch (error) {
          console.error('Owner token validation error:', error);
          setIsTokenValid(false);
          ownerLogout();
          navigate('/owner/login');
          // setShowLoginDialog(true);
        }
      }
    };

    // const checkTokenValidity = async () => {
    //   if (isCustomerAuthenticated && customerToken) {
    //     try {
    //       await api.get('/api/auth/verify-customer-token', {
    //         headers: { Authorization: `Bearer ${customerToken}` },
    //       });

    //       setIsTokenValid(true);
    //     } catch (error) {
    //       console.error('Customer token validation error:', error);
    //       setIsTokenValid(false);
    //       customerLogout();
    //       setShowLoginDialog(true);
    //     }
    //   }
    // };

    checkTokenValidity();
  }, [isOwnerAuthenticated, ownerToken, ownerLogout]);

  // const handleAuthenticatedAction = (action) => {
  //   if (!isOwnerAuthenticated || !isTokenValid) {
  //     setShowLoginDialog(true);
  //   } else {
  //     action();
  //   }
  // };
  const handleAuthenticatedAction = (action) => {
    if (isOwnerAuthenticated && isTokenValid) {
      action();
    } else {
      navigate('/owner-login');
      // setShowLoginDialog(true);
    }
  };

  return {
    isTokenValid,
    showLoginDialog,
    setShowLoginDialog,
    handleAuthenticatedAction,
  };
};

export default useOwnerAuthCheck;
